import AfricaFlag from '../../assets/images/africa.png'
import ArgentinaFlag from '../../assets/images/argentina.png'
import BrazilFlag from '../../assets/images/brazil.png'
import ChinaFlag from '../../assets/images/china.png'
import EstoniaFlag from '../../assets/images/estonia.png'
import FranceFlag from '../../assets/images/france.png'
import GermanyFlag from '../../assets/images/germany.png'
import ItalyFlag from '../../assets/images/italy.png'
import JapanFlag from '../../assets/images/japan.png'
import MauritiaFlag from '../../assets/images/mauritia.png'
import MongoliaFlag from '../../assets/images/mongolia.png'
import PortugalFlag from '../../assets/images/portugal.png'
import SpainFlag from '../../assets/images/spain.png'
import UkFlag from '../../assets/images/uk.png'
import UsaFlag from '../../assets/images/usa.png'
import WorldFlag from '../../assets/images/world.png'

const COUNTRIES = [
  {
    label: 'Mundo',
    value: 'world',
    flag: WorldFlag
  },
  {
    label: 'Africa do Sul',
    value: 'south africa',
    flag: AfricaFlag
  },
  {
    label: 'Argentina',
    value: 'argentina',
    flag: ArgentinaFlag
  },
  {
    label: 'Alemanha',
    value: 'germany',
    flag: GermanyFlag
  },
  {
    label: 'Brasil',
    value: 'brazil',
    flag: BrazilFlag
  },
  {
    label: 'China',
    value: 'china',
    flag: ChinaFlag
  },
  {
    label: 'Espanha',
    value: 'spain',
    flag: SpainFlag
  },
  {
    label: 'Estados Unidos',
    value: 'usa',
    flag: UsaFlag
  },
  {
    label: 'Estônia',
    value: 'estonia',
    flag: EstoniaFlag
  },
  {
    label: 'França',
    value: 'france',
    flag: FranceFlag
  },
  {
    label: 'Itália',
    value: 'italy',
    flag: ItalyFlag
  },
  {
    label: 'Japão',
    value: 'japan',
    flag: JapanFlag
  },
  {
    label: 'Mauritânia',
    value: 'mauritania',
    flag: MauritiaFlag
  },
  {
    label: 'Mongólia',
    value: 'mongolia',
    flag: MongoliaFlag
  },
  {
    label: 'Portugal',
    value: 'portugal',
    flag: PortugalFlag
  },
  {
    label: 'Reino Unido',
    value: 'uk',
    flag: UkFlag
  },
  
]

export default COUNTRIES;